

const swiper = new Swiper(".swiper", {
  // Optional parameters
  direction: "horizontal",
  loop: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});

const swiperothers = new Swiper(".swiper-others", {
  // Optional parameters
  direction: "horizontal",
  loop: true,
  spaceBetween: 50,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});
/*
const swiperpayment = new Swiper(".swiper-payment", {
  // Optional parameters
  direction: "horizontal",
  effect: 'fade',
  
  loop: true,
  spaceBetween: 0, 

  
});
*/

/* subscribe buttons */
function waitForElement(elementId, callBack) {
  window.setTimeout(function () {
    var element = document.getElementById(elementId);
    if (element) {
      if (window.jQuery) {
        callBack(elementId, element);
      }
    } else {
      waitForElement(elementId, callBack);
    }
  }, 500);
}
function waitForElementClass(elementId, callBack) {
  
  window.setTimeout(function () {
    
  //console.log("Searching")
    var element = document.getElementsByClassName(elementId)[0];
    if (element) {
      if (window.jQuery) {
        callBack(elementId, element);
      }
    } else {
      waitForElementClass(elementId, callBack);
    }
  }, 500);
}



waitForElement("selling_plan_8115709772075", function () {
  //replaceButtonsBoost();
  replaceButtonsBoostNew();
});
waitForElement("selling_plan_8115710656811", function () {
  //replaceButtonsFlow();
  replaceButtonsFlowNew();
});

waitForElement("selling_plan_7018988929069", function () {
  //replaceButtonsSubscribe();
  replaceButtonsSubscribeNew();
});



waitForElementClass("trustpilot-widget", function () {
  //replaceButtonsSubscribe();
  removeZindex();
});




function removeZindex(){
  console.log("Gone")
  jQuery(".trustpilot-widget").css("z-index", '');
}

function replaceButtonsSubscribeNew() {
  jQuery("#selling_plan_7018988929069").attr("size", 3);
  jQuery("input[type=radio][name=Size]").change(function () {
    //console.log("Changed");
    setTimeout(function () {
      jQuery("#price-item-custom").html(
        jQuery(".price__regular .price-item--regular").text()
      );
    }, 1500);
  });
}

function replaceButtonsFlowNew() {
  jQuery("#selling_plan_8115710656811").attr("size", 3);
}
function replaceButtonsBoostNew() {
  jQuery("#selling_plan_8115709772075").attr("size", 3);
}

function replaceButtonsBoost() {
  //alert("test");
  jQuery("#customsubscribe").empty();
  jQuery("input[name='selling_plan_1463587']").each(function (i, e) {
    var parent = jQuery(this);
    jQuery("<input type='radio' name='rsub' />")
      .attr("value", jQuery(this).val())
      .attr("checked", i == 1)
      .attr("id", "custombtns" + i)
      .click(function () {
        //console.log(parent);
        //parent.prop("checked", true);
        parent.siblings("label")[0].click();
        //console.log("Clicked");
      })
      .add(
        $(
          '<label class="longlabel" id="longlabel' +
            i +
            '" for="custombtns' +
            i +
            '">' +
            jQuery(this).siblings("label")[0].textContent +
            "</label>"
        )
      )
      .appendTo("#customsubscribe");
  });
  jQuery("#selling_plan_8115709772075 option").each(function (i, e) {
    jQuery("<input type='radio' name='r' />")
      .attr("value", jQuery(this).val())
      .attr("checked", i == 0)
      .attr("id", "custombtn" + i)
      .click(function () {
        jQuery(".rc_widget__option__input--subsave")
          .siblings("label")[0]
          .click();
        jQuery("#selling_plan_8115709772075").val(jQuery(this).val());
      })
      .add(
        $(
          '<label class="deliverysched" for="custombtn' +
            i +
            '">' +
            this.textContent +
            "</label>"
        )
      )
      .appendTo("#customsubscribe");
  });

  jQuery("input[type=radio][name=rsub]").change(function () {
    if (this.value == "onetime") {
      jQuery(".deliverysched").hide();
      jQuery("#longlabel1").css("opacity", "0.6");
      jQuery("#longlabel0").css("opacity", "1");
    } else if (this.value == "subsave") {
      jQuery(".deliverysched").show();
      jQuery("#longlabel1").css("opacity", "1");
      jQuery("#longlabel0").css("opacity", "0.6");
    }
  });

  jQuery("input[type=radio][name=Size]").change(function () {
    setTimeout(function () {
      replaceButtonsBoost();
    }, 500);
  });
}

function replaceButtonsFlow() {
  //alert("test");
  jQuery("#customsubscribe").empty();
  jQuery("input[name='selling_plan_1463586']").each(function (i, e) {
    var parent = jQuery(this);
    jQuery("<input type='radio' name='rsub' />")
      .attr("value", jQuery(this).val())
      .attr("checked", i == 1)
      .attr("id", "custombtns" + i)
      .click(function () {
        //console.log(parent);
        //parent.prop("checked", true);
        parent.siblings("label")[0].click();
        //console.log("Clicked");
      })
      .add(
        $(
          '<label class="longlabel" id="longlabel' +
            i +
            '" for="custombtns' +
            i +
            '">' +
            jQuery(this).siblings("label")[0].textContent +
            "</label>"
        )
      )
      .appendTo("#customsubscribe");
  });
  jQuery("#selling_plan_8115710656811 option").each(function (i, e) {
    jQuery("<input type='radio' name='r' />")
      .attr("value", jQuery(this).val())
      .attr("checked", i == 0)
      .attr("id", "custombtn" + i)
      .click(function () {
        jQuery(".rc_widget__option__input--subsave")
          .siblings("label")[0]
          .click();
        jQuery("#selling_plan_8115710656811").val(jQuery(this).val());
      })
      .add(
        $(
          '<label class="deliverysched" for="custombtn' +
            i +
            '">' +
            this.textContent +
            "</label>"
        )
      )
      .appendTo("#customsubscribe");
  });

  jQuery("input[type=radio][name=rsub]").change(function () {
    if (this.value == "onetime") {
      jQuery(".deliverysched").hide();
      jQuery("#longlabel1").css("opacity", "0.6");
      jQuery("#longlabel0").css("opacity", "1");
    } else if (this.value == "subsave") {
      jQuery(".deliverysched").show();
      jQuery("#longlabel1").css("opacity", "1");
      jQuery("#longlabel0").css("opacity", "0.6");
    }
  });

  jQuery("input[type=radio][name=Size]").change(function () {
    setTimeout(function () {
      replaceButtonsFlow();
    }, 500);
  });
}

function replaceButtonsSubscribe() {
  //alert("test");
  jQuery("#customsubscribe").empty();

  jQuery("#customsubscribe").append(
    "<legend class='form__label'><h4>How often?</h4></legend>"
  );

  jQuery("#selling_plan_7018988929069 option").each(function (i, e) {
    jQuery("<input type='radio' name='r' />")
      .attr("value", jQuery(this).val())
      .attr("checked", i == 0)
      .attr("id", "custombtn" + i)
      .click(function () {
        console.log("Clicked");
        jQuery("#selling_plan_7018988929069")
          .val(jQuery(this).val())
          .trigger("change");
      })
      .add(
        $(
          '<label class="deliverysched" for="custombtn' +
            i +
            '">' +
            this.textContent +
            "</label>"
        )
      )
      .appendTo("#customsubscribe");
  });
}
/* subscribe buttons end */

/* filters */
function addButton(checkbox) {
  if (checkbox.checked) {
    var button = document.createElement("button");
    button.innerHTML = checkbox.value + " &times;";
    button.value = checkbox.value;
    button.onclick = function () {
      removeButton(this);
    };
    document.getElementById("selectedItems").appendChild(button);
  } else {
    removeButton(checkbox);
  }
}

function removeButton(element) {
  var buttons = document.getElementById("selectedItems").children;
  for (var i = 0; i < buttons.length; i++) {
    if (buttons[i].value === element.value) {
      document.getElementById("selectedItems").removeChild(buttons[i]);
      break;
    }
  }
  var checkboxes = document.getElementsByTagName("input");
  for (var i = 0; i < checkboxes.length; i++) {
    if (checkboxes[i].value === element.value) {
      checkboxes[i].checked = false;
      break;
    }
  }
}

function applyFilters() {
  var selected = document.getElementById("selectedItems").children;
  console.log("Selected filters ", selected);
}
 
const swiperhor = new Swiper(".swiper-container-hor", {
  slideToClickedSlide: true,
  slidePerView: "auto",
  effect: "fade",
  freeMode: {
    enabled: false,
    sticky: true,
    momentumBounce: false,
  },
  // scrollbar: {
  //   el: ".swiper-scrollbar",
  //   draggable: false,
  //   dragSize: 100,
  // },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  mousewheel: {
    enabled: true,
    sensitivity: 5.5,
    releaseOnEdges: true,
  },
});
